const usersConfigShape = new Map();

usersConfigShape.set('firstName', {
  header: {
    title: 'common.firstname',
  },
});

usersConfigShape.set('lastName', {
  header: {
    title: 'common.lastname',
  },
});

usersConfigShape.set('nickname', {
  header: {
    title: 'common.nickname',
  },
});

usersConfigShape.set('email', {
  header: {
    title: 'common.email',
  },
});

usersConfigShape.set('mobileNumber', {
  header: {
    title: 'usersConfig.phone',
  },
});

usersConfigShape.set('role', {
  header: {
    title: 'usersConfig.role',
  },
});

export default usersConfigShape;



// WEBPACK FOOTER //
// ./src/shapes/usersConfigShape.js